import { render, staticRenderFns } from "./outCallPhone.vue?vue&type=template&id=75f139de&scoped=true&"
import script from "./outCallPhone.vue?vue&type=script&lang=ts&"
export * from "./outCallPhone.vue?vue&type=script&lang=ts&"
import style0 from "./outCallPhone.vue?vue&type=style&index=0&id=75f139de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f139de",
  null
  
)

export default component.exports